import { render } from "./LinkingOptionsDialog.vue?vue&type=template&id=6d55ca9c"
import script from "./LinkingOptionsDialog.vue?vue&type=script&lang=ts"
export * from "./LinkingOptionsDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script